export * from "../global/ui-article";
